// extracted by mini-css-extract-plugin
module.exports = {"button":"HamburgerMenu_button__23JX8","active":"HamburgerMenu_active__kCKKZ"};